import React from 'react';

/**
 * Home Navigation icon
 */
function HomeNavIcon() {
  return (
    <svg
      version="1.1"
      xmlns="https://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 638.9 629.5"
      className="c-icon-nav-size-24"
    >
      <g>
        <path
          className="c-icon-nav-path"
          d="M554.8,628.6H84.1V401.9c0-16.7,13.5-30.2,30.2-30.2s30.2,13.5,30.2,30.2v166.3h350V401.9c0-16.7,13.5-30.2,30.2-30.2s30.2,13.5,30.2,30.2V628.6z"
        />
        <path
          className="c-icon-nav-path"
          d="M574.3,176.8c-16.7,0-30.2-13.5-30.2-30.2v-40.2h-43.5c-16.7,0-30.2-13.5-30.2-30.2S484,46,500.6,46h103.9v100.6C604.5,163.3,591,176.8,574.3,176.8z"
        />
        <path
          className="c-icon-nav-path"
          d="M30.2,362.2c-7.7,0-15.5-2.9-21.3-8.8c-11.8-11.8-11.8-30.9,0-42.7L319.4,0.1L630,310.7c11.8,11.8,11.8,30.9,0,42.7c-11.8,11.8-30.9,11.8-42.7,0L319.4,85.5L51.5,353.4C45.6,359.3,37.9,362.2,30.2,362.2z"
        />
      </g>
    </svg>
  );
}

export default HomeNavIcon;



// WEBPACK FOOTER //
// ./src/layout/graphics/NavIcons/HomeNavIcon.js